import "./ExperienceDetail.scss";

const ANDDigital = () => {
  return (
    <div className="experience-detail">
      <div className="experience-detail__container">
        <div className="experience-detail__header">
          <span className="experience-detail__tenure">
            March 2024 - Current
          </span>
          <h1 className="experience-detail__title">
            Product Developer at AND Digital
          </h1>
        </div>

        <div className="experience-detail__content">
          <section className="experience-detail__section">
            <h2>Overview</h2>
            <p>
              Currently working as a Product Developer at AND Digital, within
              our clients development teams across multiple tech stacks, closing
              the digital skills gap.
            </p>
          </section>

          <section className="experience-detail__section">
            <h2>Responsibilities</h2>
            <ul>
              <li>Working embedded in client development teams</li>
              <li>Delivering solutions across multiple technology stacks</li>
              <li>Contributing to bridging the digital skills gap</li>
              <li>
                Adapting to diverse project requirements and tech environments
              </li>
            </ul>
          </section>

          <section className="experience-detail__section">
            <h2>Tech Stack</h2>
            <div className="experience-detail__tags">
              <span className="experience-detail__tag">React</span>
              <span className="experience-detail__tag">Angular</span>
              <span className="experience-detail__tag">TypeScript</span>
              <span className="experience-detail__tag">JavaScript</span>
            </div>
          </section>
        </div>

        <a href="/" className="experience-detail__back-link">
          ← Back to Portfolio
        </a>
      </div>
    </div>
  );
};

export default ANDDigital;
